( function( window, document, $ ) {
    'use strict';

    // --------------------------------------------------
    // EVENTS
    // --------------------------------------------------
    $( window ).on( 'load', function() {
        // Add 'window load' logic here.
    } );

    $( document ).ready( function() {
        const nav = $( '.js--nav' );
        const navToggle = $( '.js--nav-toggle' );
        const navClose = $( '.js--nav-close' );
        const siteBody = $( '.js--body' );
        const siteHeader = $( '.js--header' );

        navToggle.on( 'click', function() {
            if ( siteBody.hasClass( 'mobile-nav-open' ) ) {
                siteBody.removeClass( 'mobile-nav-open' );
            } else {
                siteBody.addClass( 'mobile-nav-open' );
                siteHeader.addClass( 'transform-reset' );
                $( '.js--nav-list li a' ).first().focus();
            }
        } );

        navClose.on( 'click', function() {
            siteBody.removeClass( 'mobile-nav-open' );
            navToggle.focus();
        } );

        nav.on( 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function( e ) {
            if ( ! siteBody.hasClass( 'mobile-nav-open' ) ) {
                siteHeader.removeClass( 'transform-reset' );
            }
        } );
    } );

    $( window ).on( 'scroll', scrollEventHandler );

    $( window ).on( 'resize', resizeEventHandler );


    // --------------------------------------------------
    // DECLARE FUNCTIONS
    // --------------------------------------------------
    /**
    * Wrapper around *any* logic which should be triggered on window scroll.
    */
    function scrollEventHandler( e ) {
        // Add 'window scroll' logic here.
    }

    /**
    * Wrapper around *any* logic which should be triggered on window resize.
    */
    function resizeEventHandler( e ) {
        const siteBody = $( '.js--body' );

        if ( window.innerWidth >= 1024 ) {
            siteBody.removeClass( 'mobile-nav-open' );
        }
    }
} )( window, document, jQuery );
